import { apiDomain } from "env";

const buscaDocumentos = payload =>
  `${apiDomain("portal/beneficiario")}/api/documentos/busca/ativos?` +
  `${payload?.contratoId ? `contratosId=${payload?.contratoId}&` : ""}` +
  `${payload?.codigoPlano ? `codigosPlano=${payload?.codigoPlano}&` : ""}` +
  `${payload?.tagId ? `tagId=${payload?.tagId}&` : ""}` +
  `${payload?.page ? `page=${payload?.page}&` : ""}` +
  `${payload?.size ? `size=${payload?.size}&` : ""}`;

const baixarDemonstrativoIr = (codigoBeneficiario, ano) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/demonstrativos_ir/baixar?codigoBeneficiario=${codigoBeneficiario}&ano=${ano}`;

const baixarTodosDemonstrativoIr = (codigoBeneficiarios, ano) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/demonstrativos_ir/baixar/todos_contratos?codigoBeneficiarios=${codigoBeneficiarios}&ano=${ano}`;

const baixarExtratoDespesa = (codigoBeneficiario, codigoFatura) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/extrato_despesas/baixar?codigoBeneficiario=${codigoBeneficiario}&codigoFatura=${codigoFatura}`;

const baixarFatura = downloadId =>
  `${apiDomain("portal/beneficiario")}/faturas/baixar?downloadId=${downloadId}`;

const buscaDadosCartaoFrente = beneficiarioCartao =>
  `${apiDomain(
    "portal/beneficiario"
  )}/cartao/frente?codigoBeneficiario=${beneficiarioCartao}`;

const buscaDadosReajuste = beneficiarioCartao =>
  `${apiDomain(
    "portal/beneficiario"
  )}/pinss/dados_reajuste_contrato?beneficiarioCartao=${beneficiarioCartao}`;

const buscaDadosCartaoVerso = beneficiarioCartao =>
  `${apiDomain(
    "portal/beneficiario"
  )}/cartao/verso?codigoBeneficiario=${beneficiarioCartao}`;

const extratos_pormenorizado = payload =>
  `${apiDomain("portal/beneficiario")}/extratos_pormenorizado/disponiveis` +
  `?codigoEmpresa=${payload.codigoEmpresa}` +
  `&codigoContrato=${payload.codigoContrato}`;

const downloadExtratos = payload =>
  `${apiDomain("portal/beneficiario")}/extratos_pormenorizado/download` +
  `?codigoEmpresa=${payload.codigoEmpresa}` +
  `&codigoContrato=${payload.codigoContrato}` +
  `&competencia=${payload.competencia}` +
  `&tipo=${payload.tipo}`;

const buscaExtratoDespesasFatura = (
  codigoBeneficiario,
  competenciaDe,
  competenciaAte,
  page,
  size,
  sort
) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/extrato_despesas/faturas?codigoBeneficiario=${codigoBeneficiario}&competenciaDe=${competenciaDe}&competenciaAte=${competenciaAte}&page=${page}&size=${size}&sort=${sort}`;

const buscaFaturasBeneficiario = (codigoBeneficiario, page, size, sort) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/faturas/beneficiario?codigoBeneficiario=${codigoBeneficiario}&page=${page}&size=${size}&sort=${sort}`;

const buscaParametroValorTipoBooleanAtivo = parametroId =>
  `${apiDomain("portal/beneficiario")}/parametros/${parametroId}/tipo/boolean`;

const buscaPeriodoAnoDemonstrativoIr = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/demonstrativos_ir/ano/listar?codigoBeneficiario=${codigoBeneficiario}`;

const cep = cep =>
  `${apiDomain("portal/beneficiario")}/enderecos_cep?cep=${cep}`;

const createUsuario = () => `${apiDomain("portal/beneficiario")}/usuarios`;

const getAnexo = arquivoId =>
  `${apiDomain("portal/beneficiario")}/anexos/download/${arquivoId}`;

const downloadCartaPortabilidade = (geraFamilia, codigoBeneficiario) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/carta_portabilidade/baixar?gerarFamilia=${geraFamilia}
&codigoBeneficiario=${codigoBeneficiario}`;

const getAvatar = () => `${apiDomain("portal/beneficiario")}/usuarios/avatar`;

const beneficiariosUsuario = () =>
  `${apiDomain("portal/beneficiario")}/beneficiarios/usuario`;

const valoresPlano = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/valores_plano?codigoBeneficiario=${codigoBeneficiario}`;

const graphql = `${apiDomain("portal/beneficiario")}/graphql`;

const parametroLogout = unimedId =>
  `${apiDomain("portal/beneficiario")}/parametros/logout/${unimedId}`;

const recuperarSenha = `${apiDomain}/administracao/usuarios/recuperar_senha`;

const redefinirSenha = `${apiDomain}/administracao/usuarios/redefinir_senha`;

const alterarSenha = `${apiDomain}/administracao/usuarios/reset_password`;

const token = `${apiDomain}/uaa2/oauth/token`;

const unimeds = `${apiDomain("portal/beneficiario")}/empresas/unimeds`;

const updateAvatar = () =>
  `${apiDomain("portal/beneficiario")}/usuarios/avatar`;

const updatePassword = unimedId =>
  `${apiDomain("portal/beneficiario")}/usuarios/${unimedId}`;

const urlPrimeiroAcesso = `${apiDomain(
  "portal/beneficiario"
)}/empresas/primeiro_acesso`;

const verificaRepasse = `${apiDomain(
  "portal/beneficiario"
)}/beneficiario_repasse/verificar`;

const downloadFormulario = formularioId =>
  `${apiDomain("portal/beneficiario")}/formularios/${formularioId}`;

const validaFaturaAcaoJudicial = faturaId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/verifica_fatura/acao_judicial?faturaId=${faturaId}`;
const validaVencimentoFatura = faturaId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/verifica_fatura/vencimento?faturaId=${faturaId}`;

const createParcelamento = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/cria_atualiza_parcelamento`;

const listFaturaEmAberto = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/lista_parcelamento_qtd`;

const atualizarQtdParcelamento = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/atu_qtd_parcelamento`;

const visualizarParcelamento = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/visualiza_parcelamento`;

const concluiParcelamento = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/conclui_parcelamento`;

const relatorioParcelamento = `${apiDomain(
  "portal/beneficiario"
)}/plapiconnect/relatorio_parcelamento`;

const cadastroBeneficiarioDesatualizado = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/beneficiarios_atualizacao_cadastral?codigoBeneficiario=${codigoBeneficiario}`;

const gravaHistoricoAtualizacaoCadastral = `${apiDomain(
  "portal/beneficiario"
)}/beneficiarios_atualizacao_cadastral`;

const getDetalhamentoRenegociacao = faturaId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/faturas/renegociacao?faturaId=${faturaId}`;

const lgpdEnabled = product => `${apiDomain}/lgpd/policies/enabled/${product}`;
const lgpdDownload = uuid => `${apiDomain}/lgpd/documents/${uuid}/download`;

export default {
  buscaDocumentos,
  baixarDemonstrativoIr,
  baixarTodosDemonstrativoIr,
  baixarExtratoDespesa,
  baixarFatura,
  beneficiariosUsuario,
  buscaDadosCartaoFrente,
  buscaDadosCartaoVerso,
  buscaExtratoDespesasFatura,
  buscaFaturasBeneficiario,
  buscaParametroValorTipoBooleanAtivo,
  buscaPeriodoAnoDemonstrativoIr,
  cep,
  createUsuario,
  getAnexo,
  getAvatar,
  graphql,
  parametroLogout,
  recuperarSenha,
  redefinirSenha,
  valoresPlano,
  alterarSenha,
  token,
  unimeds,
  updateAvatar,
  updatePassword,
  urlPrimeiroAcesso,
  downloadFormulario,
  downloadCartaPortabilidade,
  verificaRepasse,
  validaFaturaAcaoJudicial,
  validaVencimentoFatura,
  buscaDadosReajuste,
  extratos_pormenorizado,
  downloadExtratos,
  createParcelamento,
  listFaturaEmAberto,
  atualizarQtdParcelamento,
  visualizarParcelamento,
  concluiParcelamento,
  relatorioParcelamento,
  lgpdEnabled,
  lgpdDownload,
  cadastroBeneficiarioDesatualizado,
  gravaHistoricoAtualizacaoCadastral,
  getDetalhamentoRenegociacao
};
